import { resolveApiBase, resolveSocketUrl } from '@config/apiBase';

const origin = window.location.origin;

export const ApiUrl: { server_url: string; socket_url: string } = {
  server_url: resolveApiBase(origin),
  socket_url: resolveSocketUrl(origin),
};
